import { render, staticRenderFns } from "./CartPriceAll.vue?vue&type=template&id=38059d44"
import script from "./CartPriceAll.vue?vue&type=script&lang=ts"
export * from "./CartPriceAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports